var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M31.22 35c1.575-2.558 2.447-5.528 2.447-8.461 0-1.293-.133-2.557-.457-3.781-.237-.844-.926-1.508-1.826-1.508-.543 0-1.036.238-1.37.619v-.16a1.83 1.83 0 00-1.826-1.834c-1.009 0-1.826.82-1.826 1.833v-.916a1.83 1.83 0 00-1.826-1.834 1.83 1.83 0 00-1.826 1.834v-5.959A1.829 1.829 0 0020.884 13a1.83 1.83 0 00-1.826 1.833v10.455a.915.915 0 01-1.165.88l-2.579-1.054a1.826 1.826 0 00-.822-.197c-1.008 0-1.825.82-1.825 1.833 0 .76.465 1.416 1.123 1.695 2.962 1.536 5.337 3.42 6.998 6.555h10.431z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
